        
<div >
    <div class="iq-client iq-client-style-1 ">
        <ul class="iq-client-col-6 iq-client-grid">
            <li *ngFor="let list of Images">
                <img src="{{ list.image }}" class="img-fluid {{list.class}}" alt="client-img">
            </li>
        </ul>
    </div>
</div>
